// Orbit HRM: a vacancy's priority (as the API stores it: 1 High, 2 Normal, 3 Low)
export const PRIORITIES = [
  {id: 1, label: 'High', tone: 'red'},
  {id: 2, label: 'Normal', tone: 'blue'},
  {id: 3, label: 'Low', tone: 'grey'},
];

export const priorityOption = (id) =>
  PRIORITIES.find((p) => p.id === id) || PRIORITIES[1];

// and its status: the API's status (active) plus onHold, which only a closed one can be
export const STATUSES = [
  {id: 'active', label: 'Active', tone: 'green', status: true, onHold: false},
  {id: 'onHold', label: 'On hold', tone: 'amber', status: false, onHold: true},
  {id: 'closed', label: 'Closed', tone: 'grey', status: false, onHold: false},
];

export const statusId = (vacancy) =>
  vacancy.status ? 'active' : vacancy.onHold ? 'onHold' : 'closed';
